import './about.css'
const About = () => {
  return (
    <section id='about'>
      <h2>About Me</h2>

      <div className="about_container">
        <div className="about_content">
          <p>
            I am a PhD candidate specializing in Generative Artificial Intelligence, Brain-Computer Interfaces, and Speech Generation. My research focuses on advancing AI systems that create natural and expressive human-like interactions, with an emphasis on bridging human and machine communication.
          </p>
          <p>
            Alongside my research, I mentor the Computer Science Project course at UNSW, where I support students in software system development, teamwork, and effective technical communication.
          </p>
        </div>
      </div>
    </section>
  )
}

export default About
